import { Env2 } from '@toy/utils';

// 环境枚举
export enum ENV_ENUM {
  DEV = 'dev',
  QA = 'qa',
  UAT = 'uat',
  PROD = 'prod',
}

// 系统枚举
export enum SYSTEM_ENUM {
  NEST_API = 'nest-api',
  ARSENAL_API = 'arsenal-api',
  NEST_WEB = 'nest-web',
  LOGIN_WEB = 'login-web',
  OLA_API = 'ola-api',
  TIANGONG_OSS_SERVER = 'tiangongOssServer',
  TIANGONG_API = 'tiangong',
  FASHION_DESIGN_API = 'FashionDesignApi',
  SCM_OSS_SERVER = 'scm_ossServer',
  TG_FASHION_DESIGN_API = 'FashionDesignApi',
  TG_FASHION_MIND_API = 'tgFashionMindApi',
  SSO = 'sso',
  TG_FASHION_PHOTO = 'tgFashionPhoto',
  OPEN_PLATFORM_API = 'openPlatformApi',
}

export const envInstance = new Env2<ENV_ENUM, SYSTEM_ENUM>({
  onlineEnv: window.$frontEnv,
  /* 本地环境 使用环境 */
  localEnv: ENV_ENUM.QA,
  onlineDomain: 'tiangong.tech',
  localDomain: 'tiangong.tech',
});

// 获取 api 前置路径
export const { API_BASE, currentEnv } = envInstance;

export const currentSystem = window.$system as string || 'fashion-design-admin';

export const ENV_PREFIX = window.location.host;
